import * as React from 'react';
import { NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuTrigger } from '@cuspar/ui';
import { ROUTES } from '../../routes';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

export function DomainsMenu() {
  const { t } = useTranslation();
  const components = [
    {
      title: t('nav.registration'),
      to: ROUTES.domains.search,
      description: t('nav.registrationDescription'),
    },
    {
      title: t('nav.transfer'),
      to: ROUTES.domains.transfer,
      description: t('nav.transferDescription'),
    },
    {
      title: t('nav.tldPrices'),
      to: ROUTES.domains.prices,
      description: t('nav.tldPricesDescription'),
    },
  ];
  return (
    <NavigationMenuItem>
      <NavigationMenuTrigger className='bg-accent' onPointerMove={(event) => event.preventDefault()} onPointerLeave={(event) => event.preventDefault()}>
        {t('common.domain')}
      </NavigationMenuTrigger>
      <NavigationMenuContent onPointerMove={(event) => event.preventDefault()} onPointerLeave={(event) => event.preventDefault()}>
        <ul className='grid w-80 gap-1 p-4'>
          {components.map((component) => (
            <MenuListItem key={component.to} component={component}>
              {component.description}
            </MenuListItem>
          ))}
        </ul>
      </NavigationMenuContent>
      {components.map((component) => (
        <a className='sr-only' href={component.to} key={component.to}>
          {component.title}
        </a>
      ))}
    </NavigationMenuItem>
  );
}

export const MenuListItem: React.FC<{ component: { title: string; to: string; description: string }; children: React.ReactNode }> = ({ component, children }) => {
  return (
    <li>
      <NavigationMenuLink asChild>
        <Link
          to={component.to}
          className='block select-none space-y-1 rounded-xs p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground'
        >
          <div className='text-sm font-medium leading-none'>{component.title}</div>
          <p className='line-clamp-2 text-xs font-medium leading-snug text-muted-foreground'>{children}</p>
        </Link>
      </NavigationMenuLink>
    </li>
  );
};
